import { Box, styled } from '@mui/material'

// Global UI
import { TypographyH2, TypographyH3, TypographyP } from '@/ui'

export const WhyChooseUsDiv = styled(Box)(({ theme }) => ({
  background: '#F6F6F6',
  padding: `${theme.typography.pxToRem(70)} 0`,
}))

export const SectionHeadH2 = styled(TypographyH2)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(30),
  color: '#8E8778',
  fontWeight: 500,
  lineHeight: '1.3em',
  textTransform: 'uppercase',
  margin: 0,
  padding: 0,
}))

export const SubDiv = styled(Box)(({ theme }) => ({
  padding: `${theme.typography.pxToRem(30)} 0`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const IconBgDiv = styled(Box)(({ theme }) => ({
  backgroundColor: '#BDB29C',
  width: theme.typography.pxToRem(32),
  height: theme.typography.pxToRem(32),
  padding: theme.typography.pxToRem(24),
  borderRadius: '50%',
  transition: 'all 3s ease',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.typography.pxToRem(10),

  '&:hover': {
    transform: 'scale(1.2)',
    marginBottom: theme.typography.pxToRem(15),
  },

  '& .MuiSvgIcon-root': {
    color: '#FFF',
    width: '1em',
    height: '1em',
  },
}))

export const TitleH3 = styled(TypographyH3)(({ theme }) => ({
  color: '#1E1D24',
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 500,
  lineHeight: '1.44em',
  margin: `0 0 ${theme.typography.pxToRem(11)} 0`,
  textTransform: 'capitalize',
}))

export const SubTitleP = styled(TypographyP)(({ theme }) => ({
  color: '#000',
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 300,
  lineHeight: '1.643em',
  margin: 0,
  padding: 0,
  marginBlock: 0,
}))
